import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { walletConnect, checkMetamask, okxwalletConnect, checkOkxwallet, switchChain } from '@/utils/connect.js';
export default {
  name: 'prompt',
  props: {
    title: {
      "default": ''
    },
    description: {
      "default": ''
    },
    type: {
      "default": 1
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false
    };
  },
  methods: {
    handleConfirm: function handleConfirm() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$emit('handleConfirm');
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCancle: function handleCancle() {
      this.visible = false;
      this.$emit('handleCancle');
    }
  }
};